import { FieldGuesser, InputGuesser, ListGuesser, ShowGuesser } from '@api-platform/admin'
import React from 'react'
import {
    Create as BaseCreate,
    Edit as BaseEdit,
    FunctionField,
    ReferenceField,
    ReferenceInput,
    required,
    SaveButton,
    SelectInput,
    SimpleForm,
    Toolbar,
    useRecordContext,
} from 'react-admin'
import ReferenceFileInput from '../inputs/ReferenceFileInput'
import ImageField from '../fields/ImageField'

const Title = () => {
    const record = useRecordContext()

    return <span>{record ? `${record?.name}` : ''}</span>
}

const EditToolbar = (props) => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
)

const InputFields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <SimpleForm toolbar={<EditToolbar />}>
            <InputGuesser label='Name' source='name' fullWidth isRequired validate={[required()]} />
            <InputGuesser label='Code' source='code' fullWidth isRequired validate={[required()]} />
            <InputGuesser label='Icon' source='icon' fullWidth />
            <InputGuesser label='Position' source='position' />

            <ReferenceInput source='parent' reference='categories'>
                <SelectInput optionText='name' fullWidth />
            </ReferenceInput>

            <ReferenceFileInput source='cover' label='Cover' accept='image/*' srcPath='contentUrl' reference='medias' />
        </SimpleForm>
    </Guesser>
)

const Fields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <FieldGuesser label='Name' source='name' />
        <FieldGuesser label='Code' source='code' />
        <FieldGuesser label='Icon' source='icon' />

        <ReferenceField source='parent' reference='categories' sortable={false}>
            <FunctionField render={(record) => record?.name} />
        </ReferenceField>

        <ReferenceField source='cover' reference='medias' sortable={false}>
            <ImageField source='contentUrl' label='Cover' />
        </ReferenceField>
    </Guesser>
)

export const Create = (props) => <InputFields Guesser={BaseCreate} title={`CREATE`} {...props} />

export const Edit = (props) => <InputFields Guesser={BaseEdit} title={<Title />} {...props} />

export const Show = (props) => <Fields Guesser={ShowGuesser} title={<Title />} {...props} />

export const List = (props) => <Fields Guesser={ListGuesser} {...props} />

const Category = {
    list: List,
    edit: Edit,
    create: Create,
    show: Show,
}

export default Category
